import { render, staticRenderFns } from "./BonusSectionSetting.vue?vue&type=template&id=38b2bf0b&scoped=true&"
import script from "./BonusSectionSetting.vue?vue&type=script&lang=ts&"
export * from "./BonusSectionSetting.vue?vue&type=script&lang=ts&"
import style0 from "./BonusSectionSetting.vue?vue&type=style&index=0&id=38b2bf0b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2bf0b",
  null
  
)

export default component.exports